(function() { window.GUID_0260b33d_7397_487f_b3f5_4a73cdc15902 = { getGuid: function() { return "0260b33d-7397-487f-b3f5-4a73cdc15902"; } }; })();
var CS;
(function (CS) {
    var App;
    (function (App) {
        var Views;
        (function (Views) {
            var _Shared;
            (function (_Shared) {
                var WallSections;
                (function (WallSections) {
                    CS.Controls.Accordion.Events.Rendered({
                        selector: "body",
                        childSelector: ".accordion-matches-v2",
                        callback: (accordion, e) => {
                            const { isWallLayout } = WallSections.MatchesSection;
                            if (isWallLayout) {
                                WallSections.MatchesSection.setObservers(accordion);
                                //MatchesSection.appendFiltersCounterInTopBar();
                                const $chips = accordion.$Content.find(".chips");
                                if ($chips.length) {
                                    //$chips.css({
                                    //    top: `${Math.floor($("#section-top").outerHeight()) - 1}px`,
                                    //});
                                    $chips.removeClass("hiddenforced");
                                }
                            }
                        },
                    });
                })(WallSections = _Shared.WallSections || (_Shared.WallSections = {}));
            })(_Shared = Views._Shared || (Views._Shared = {}));
        })(Views = App.Views || (App.Views = {}));
    })(App = CS.App || (CS.App = {}));
})(CS || (CS = {}));

//# sourceMappingURL=matches-section.rendered.js.map
